/**
 * 段階評価 (rating-scale) のボタン群 (入力項目の userFields / postFields 共通、2026-10-07)。
 *
 * ボタンは行幅いっぱいに等幅で並べ、両端の言葉 (negLabel / posLabel) はボタン列の
 * 左端・右端の真下に揃える。PC で横に間延びしないよう行幅に上限を持たせ、
 * ラベルも同じ幅の箱に入れるので、端末幅に関係なくボタン列と言葉の位置がずれない。
 */
export interface RatingScaleButtonsProps {
  steps: number[];
  selected: number | undefined;
  onSelect: (value: number) => void;
  negLabel?: string;
  posLabel?: string;
  disabled?: boolean;
  /** radiogroup の名前を指す要素の id。 */
  labelledBy?: string;
}

export function RatingScaleButtons({
  steps,
  selected,
  onSelect,
  negLabel,
  posLabel,
  disabled,
  labelledBy,
}: RatingScaleButtonsProps) {
  const neg = negLabel?.trim();
  const pos = posLabel?.trim();
  // 段階が多いときだけ上限を広げ、1 個あたりの押しやすさを保つ。
  const widthClass = steps.length > 7 ? 'max-w-2xl' : 'max-w-md';
  return (
    <div className={`w-full ${widthClass}`}>
      <div role="radiogroup" aria-labelledby={labelledBy} className="flex gap-1.5">
        {steps.map((n) => {
          const active = selected === n;
          return (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={active}
              disabled={disabled}
              onClick={() => onSelect(n)}
              className={`flex-1 min-w-0 min-h-touch rounded-lg border text-sm font-medium tabular-nums transition-colors disabled:opacity-50 ${
                active
                  ? 'bg-primary-600 text-white border-primary-600 shadow-sm'
                  : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50 hover:border-slate-400'
              }`}
            >
              {n > 0 ? `+${n}` : n}
            </button>
          );
        })}
      </div>
      {(neg || pos) && (
        <div className="mt-1.5 flex items-start justify-between gap-3 text-xs leading-snug text-slate-500">
          <span className="min-w-0 max-w-[50%] break-words text-left">{neg ?? ''}</span>
          <span className="min-w-0 max-w-[50%] break-words text-right">{pos ?? ''}</span>
        </div>
      )}
    </div>
  );
}
